<brd-hero-image></brd-hero-image>
<brd-maintenance-alert></brd-maintenance-alert>
<div class="section-container">
  <div class="news-header">
    <div class="title">News</div>
    <div class="subtitle">
      Here you find the latest news of the Board Demo Portal. Click on a News tile to read and get more details about.
    </div>
  </div>
  <div class="news-body">
    <div class="news-container" *ngIf="news$ | async as news">
      <ng-container *ngIf="!loading(); else loader">
        <div class="news-grid" *ngIf="news.length; else noNews">
          <div
            *ngFor="let n of news; index as i"
            [class]="'news-item news-item-' + n.size"
            [style]="{ borderColor: n.categoryBackground }"
            (click)="openNewsPopup(n, i, news.length)"
          >
            <div class="news-item-badges">
              <div
                class="news-item-category"
                [style]="{ borderColor: n.categoryBackground, background: n.categoryBackground + '33' }"
                [title]="n.categoryName"
              >
                {{ n.categoryName }}
              </div>
              <div class="news-item-toread" *ngIf="n.isToRead">NEW!</div>
            </div>
            <div class="news-item-title" [title]="n.title">{{ n.title }}</div>
            <div class="news-item-text">
              <div *ngIf="n.updates.length" class="news-item-updates">
                <div class="news-item-updates-title">Updates:</div>
                <div class="news-item-updates-list">
                  <div *ngFor="let u of n.updates" class="news-item-updates-item">
                    <span class="news-item-updates-date">
                      {{ u.updateDate | date: "MM/dd/yyyy 'h' HH:mm" }}
                    </span>
                    <span style="white-space: pre-line">{{ u.text }}</span>
                  </div>
                </div>
              </div>
              <div [innerHTML]="n.description"></div>
            </div>
            <div class="news-item-publish">
              Published on <strong>{{ n.publishDate | date: "MMMM dd, yyyy 'h' HH:mm" }}</strong>
            </div>
          </div>
        </div>
      </ng-container>
      <div class="news-pagination-container">
        <brd-button
          color="no-border"
          text="prev"
          iconName="arrow-left-16"
          [style]="{
            visibility: currentPage <= 1 ? 'hidden' : 'visible'
          }"
          (click)="loadNews(currentPage - 2)"
        ></brd-button>
        <div class="page-conatiner" *ngIf="pages()">
          <brd-button
            color="no-border"
            *ngFor="let page of pages()"
            [text]="page"
            (click)="loadNews(page - 1)"
            class="button-page"
            [ngClass]="{
              selected: currentPage === page
            }"
          ></brd-button>
        </div>
        <brd-button
          class="next-button"
          color="no-border"
          text="next"
          iconName="arrow-right-16"
          [style]="{
            visibility: currentPage === totalPages ? 'hidden' : 'visible'
          }"
          (click)="loadNews(currentPage)"
        ></brd-button>
      </div>
    </div>
    <div class="filter-container">
      <div class="filter">
        <div class="filter-title">Real-Time Search</div>
        <dx-text-box
          stylingMode="outlined"
          placeholder="Search"
          [(value)]="searchText"
          valueChangeEvent="input"
          (onValueChanged)="onSearchChange()"
        >
          <dxi-button name="search" location="before" [options]="searchButtonOptions"></dxi-button>
        </dx-text-box>
      </div>
      <ng-container *ngIf="filters$ | async as filters">
        <div class="filter">
          <div class="filter-title">Choose Category</div>
          <div class="category-container">
            <div
              *ngFor="let c of filters.categories"
              [style]="{ borderColor: c.color, background: c.color + '33' }"
              class="category"
              [ngClass]="{ 'not-selected': !!selectedCategories.length && !selectedCategories.includes(c.id) }"
              (click)="selectCategory(c.id)"
            >
              {{ c.name }}
            </div>
          </div>
        </div>
        <div class="filter">
          <div class="filter-title">Related Assets</div>
          <dx-tag-box
            valueExpr="id"
            displayExpr="name"
            [dataSource]="filters.assets"
            labelMode="floating"
            stylingMode="outlined"
            [showClearButton]="true"
            [searchEnabled]="true"
            searchExpr="name"
            (onValueChanged)="selectedDemoAssetsChanges($event)"
          ></dx-tag-box>
        </div>
      </ng-container>
    </div>
  </div>
</div>
<brd-contact-support></brd-contact-support>
<ng-template #loader>
  <div class="loader-container">
    <mat-progress-spinner diameter="60" mode="indeterminate" strokeWidth="5"></mat-progress-spinner>
  </div>
</ng-template>
<ng-template #noNews>
  <div class="no-news"><span>No news available</span></div>
</ng-template>
